module.exports = __webpack_public_path__ + "assets/img/ps-0-light.3e677298.png";